export default function findAccessToken(link: string) {
  const persistStorage = localStorage.getItem("persist:rtk:access_token");
  if (!persistStorage) return;
  return JSON.parse(
    JSON.parse(localStorage.getItem("persist:rtk:access_token")).queries
  )[`getAuth("${link}")`]?.data?.access_token;
}
